export default class SecondaryNav {
  constructor($header) {
    this.$nav = $header.find('.js-header-secondary-nav');
  }

  init(user) {
    if (!this.$nav.length) {
      return;
    }

    this.showNav();

    this.setUserPicture(user && user.thumbnailUrl);
  }

  showNav() {
    this.$nav.find('> .is-hidden').removeClass('is-hidden');
  }

  setUserPicture(thumbnailUrl) {
    if (!thumbnailUrl) return;

    try {
      const $thumbnailWrapper = this.$nav.find('.js-header-user-thumbnail');
      const $userIcon = $thumbnailWrapper.find('svg');
      const $userPicture = $thumbnailWrapper.find('img');

      const picture = new Image();

      picture.onload = () => {
        $userIcon.remove();
        $userPicture.attr({ src: thumbnailUrl });
      };

      picture.src = thumbnailUrl;
    } catch (e) {
      console.error('Couldn\'t set user picture', e);
    }
  }
}
